module.exports = "/_next/static/images/seed_single-44ee672c77fb12131d6b8db30216f15c.svg";